/**
 * API Configuration and Axios instance for Wysspr
 */
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = BACKEND_URL?.replace('https://', 'wss://').replace('http://', 'ws://');
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// API instance with credentials
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add auth header interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wysspr_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses globally - clear token on explicit unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only remove token if it's a genuine auth failure, not during login
      const isAuthEndpoint = error.config?.url?.includes('/auth/');
      if (!isAuthEndpoint) {
        localStorage.removeItem("wysspr_token");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
